import type React from "react";
import styles from "./LoadingSpinner.module.css";
import clsx from "clsx";

type SpinnerSize = "sm" | "md" | "lg";

interface LoadingSpinnerProps {
  size?: SpinnerSize;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = "md" }) => {
  return (
    <div className={clsx(styles.wrapper, styles[size])}>
      <svg viewBox="0 0 50 50" className={styles.spinner}>
        <title>spinner</title>
        <circle className={styles.track} cx="25" cy="25" r="20" fill="none" />
        <circle className={styles.arc} cx="25" cy="25" r="20" fill="none" />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
